<div class="container">
	@if (!isLoading) {
		<h2>Admin UI Login</h2>

		<form [formGroup]="devLoginForm" (ngSubmit)="onSubmit()">
			<form-field label="{{ 'login.username' | translate }}" labelDirection="top-modal">
				<input-field
					formControlName="username"
					id="js-e2e-username"
					placeholder="{{
						'common.enter.item' | translate: { item: 'login.username' | translate | lowercase }
					}}"
				/>
			</form-field>

			<form-field label="{{ 'login.password' | translate }}" labelDirection="top-modal">
				<input-field
					formControlName="password"
					id="js-e2e-password"
					placeholder="{{
						'common.enter.item' | translate: { item: 'login.password' | translate | lowercase }
					}}"
					type="password"
				/>
			</form-field>

			<button
				class="button"
				color="primary"
				id="js-e2e-login-button"
				mat-raised-button
				type="submit"
			>
				Login
			</button>
		</form>
	} @else {
		<div class="loading-container">
			<mat-progress-spinner class="progress-spinner" mode="indeterminate" />
			<mat-icon class="icon" svgIcon="ic-dolphin" />
		</div>
	}
</div>
